import { FireAndFlowerCardData } from './fire-and-flower-card-data';

export class FireAndFlowerRegularPriceCardData extends FireAndFlowerCardData {
  public readonly showRegularPriceAtBottom: boolean = false;
}
